"use client";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { timeMsToSrt } from "@/lib/subs/srt";
import { cn } from "@/lib/utils";

export const ChaptersView = ({
  chapters,
  videoElementId,
  ...props
}: React.HTMLProps<HTMLDivElement> & {
  chapters: { start_ms: number; summary: string }[];
  videoElementId: string;
}) => {
  const [showAllChapters, setShowAllChapters] = useState(false);
  const t = useTranslations();

  const chaptersToShow = showAllChapters ? chapters : chapters.slice(0, 5);

  return (
    <div {...props}>
      <div className="space-y-1">
        {chaptersToShow.map((chapter) => {
          return (
            <div key={chapter.start_ms}>
              <div
                role="button"
                className="text-primary"
                onClick={() => {
                  const videoElement = document.getElementById(videoElementId) as
                    | HTMLVideoElement
                    | undefined;
                  if (videoElement) {
                    videoElement.currentTime = chapter.start_ms / 1000;
                  }
                }}
              >
                {timeMsToSrt({ timeMs: chapter.start_ms, keepMinutes: true })}
              </div>
              <p className={cn({ "line-clamp-1": !showAllChapters })}>{chapter.summary}</p>
            </div>
          );
        })}
      </div>
      {!showAllChapters && (
        <div className="mt-2">
          <Button
            variant="ghost"
            className="text-primary"
            onClick={() => {
              setShowAllChapters(!showAllChapters);
            }}
          >
            {t("general.more")}
          </Button>
        </div>
      )}
    </div>
  );
};
